import { notification } from 'antd'
import { stakeholderService } from '../services'
import i18nextConfig from '../../../config/i18next'

export default (userId, passwordCurrent, passwordNew, passwordNewConfirm) => {
  return new Promise((resolve, reject) => {
    if (passwordCurrent === '' || passwordNew === '' || passwordNewConfirm === '') {
      notification['error']({message: i18nextConfig.t('messages.aml.missingRequiredField')})
      return false
    }
    if (passwordNew !== passwordNewConfirm) {
      notification['error']({message: i18nextConfig.t('messages.aml.errors.passwordsDontMatch')})
      return false
    }
    stakeholderService.changePwd(userId, passwordCurrent, passwordNew)
        .then(response => {
          resolve({success: true, data: response})
        })
        .catch(data => {
          if (data.response.status === 500) {
            reject({success: false, data: data.response.data})
          } else {
            resolve({success: false, data: data.response})
          }
        })
  })
}
